import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Icon,
  // MobileStepper,
  // Paper,
  Snackbar,
  Typography,
  Button,
  Card,
  Divider,
  TextField,
  MenuItem,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Link,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import AppHeader from "../../components/header";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";
import usePageTitle from "../../pageTitle";

function AgentProductPage() {
  const [pageTitle, setPageTitle] = useState("Laddar Africa");
  usePageTitle(pageTitle);

  const { agentRef, ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [productReference, setProductReference] = useState(null);
  const [campaign, setCampaign] = useState({});
  const [webstore, setWebstore] = useState({});
  const [product, setProduct] = useState(null);
  const [productName, setProductName] = useState(null);
  const [productDescription, setProductDescription] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [productPrice, setProductPrice] = useState(0.0);
  const [productCurrency, setProductCurrency] = useState(null);

  const [index, setActiveStep] = useState(0);
  const [productImageSize, setProductImageSize] = useState(0);

  const [selectedQty, setSelectedQty] = useState(1);
  const [selectedVariants, setSelectedVariants] = useState([]);

  const [selectCampaignProductVariants, setSelectCampaignProductVariants] =
    useState([]);
  const [tempSelectedVariants, setTempSelectedVariants] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [selectedProductAmount, setSelectedProductAmount] = useState(0);

  // Function to go to the next picture
  const goToNextPicture = () => {
    if (index === productImageSize - 1) {
      setActiveStep(0);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const goBackToPicture = () => {
    if (index === 0) {
      setActiveStep(productImageSize - 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`checkout/products/${agentRef}/${ref}/fetch.json`)
        .then((result) => {
          console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setWebstore(result.data.data.product.webstore);
            setCampaign(result.data.data.campaign);
            setProduct(result.data.data.product);
            setProductReference(result.data.data.product.reference);
            setProductName(result.data.data.product.title);
            setProductDescription(result.data.data.product.description);
            setProductImages(result.data.data.product.images);
            setProductVariants(result.data.data.product.variants);
            setProductPrice(result.data.data.product.price);
            setProductImageSize(result.data.data.product.images.length);
            setProductCurrency(result.data.data.product.currency);

            setSelectedProductAmount(result.data.data.product.price);

            setPageTitle(`${result.data.data.product.title} | Laddar Africa`);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function addToCart() {
    const tNum = Number(selectedQuantity);
    if (!tNum) {
      setErrMsg("Invalid product quantity");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (parseInt(selectedQuantity, 10) <= 0) {
      setErrMsg("Product quantity is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (product.order_quantity > 0) {
      if (selectedQuantity > product.order_quantity) {
        setErrMsg(
          `Product quantity can not be more than ${product.order_quantity}`,
        );
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    if (productVariants.length > 0) {
      if (selectedVariants.length !== productVariants.length) {
        setErrMsg("All product option(s) are required.");
        setSeverity("error");
        setOpen(true);
        return false;
      }
    }

    if (!product.is_price_fixed) {
      if (selectedProductAmount < product.price_minimum) {
        setErrMsg(
          `Amount can not be less than ${productCurrency}${(
            product.price_minimum / 100
          ).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
        );
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (product.price_maximum > 0) {
        if (selectedProductAmount > product.price_maximum) {
          setErrMsg(
            `Amount can not be more than ${productCurrency}${(
              product.price_maximum / 100
            ).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
          );
          setSeverity("error");
          setOpen(true);
          return;
        }
      }

      if (selectedProductAmount <= 0) {
        setErrMsg("Invalid amount entered.");
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    const payload = {
      agent_reference: agentRef,
      product_reference: ref,
      product: {
        reference: productReference,
        name: productName,
        amount: selectedProductAmount,
        currency: productCurrency,
        quantity: selectedQuantity,
        variants: selectedVariants,
        image: `${productImages[0]}`,
      },
    };

    // console.log(payload);
    localStorage.setItem(
      AppConfig.product_cart_storage_label,
      JSON.stringify(payload),
    );

    navigate(`/p/checkout`);
    return;
  }

  return (
    <>
      <Container>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
        {product !== null ? (
          <Box sx={{ margin: "55px auto" }}>
            <Box mb={1} px={1}>
              <Typography fontWeight={300} fontSize={14}>
                {campaign.title}
              </Typography>
            </Box>
            <Box mb={0}>
              <Divider />
            </Box>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Box p={3} align="center">
                  <Box sx={{ width: 1 }}>
                    <img
                      // src="https://placehold.co/600x400.png"
                      src={`${AppConfig.api_media_url}${productImages[index]}`}
                      alt="img"
                      width="80%"
                    />
                  </Box>
                  {productImageSize > 1 ? (
                    <Box mt={2}>
                      <Grid container spacing={3}>
                        <Grid item xs={6} md={6} lg={6}>
                          <Box>
                            <Button
                              size="small"
                              onClick={goBackToPicture}
                              variant="outlined"
                            >
                              <KeyboardArrowLeft />
                            </Button>
                          </Box>
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                          <Box>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={goToNextPicture}
                            >
                              <KeyboardArrowRight />
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : (
                    <> </>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }} elevation={2}>
                  {/* <Card elevation={2}> */}
                  <Box p={3} sx={{ height: "100%" }}>
                    <Box mb={3}>
                      <Typography variant="subtitle1" fontWeight={100} mt={0}>
                        {productName}
                      </Typography>
                      <Typography
                        variant="h4"
                        fontWeight={600}
                        color="text"
                        mt={2}
                      >
                        {product.is_price_fixed ? (
                          <>
                            <small>{productCurrency}</small>
                            {(productPrice / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </>
                        ) : (
                          <> </>
                        )}
                      </Typography>
                    </Box>
                    <Divider />
                    <Box>
                      {!product.is_price_fixed ? (
                        <Box mt={3} mb={3}>
                          <Box px={0}>
                            <Typography variant="caption" fontWeight="regular">
                              ENTER AMOUNT
                            </Typography>
                          </Box>
                          <Box mt={3}>
                            <TextField
                              sx={{
                                size: {
                                  xs: "small",
                                  md: "large",
                                  lg: "large",
                                },
                              }}
                              // value={selectedProductAmount}
                              type="decimal"
                              label="Amount"
                              fullWidth
                              onChange={(e) =>
                                setSelectedProductAmount(
                                  parseFloat(e.target.value, 10) * 100,
                                )
                              }
                            />
                          </Box>
                        </Box>
                      ) : (
                        <> </>
                      )}
                      {/* {productVariants.length > 0 ? (
                        <Box>
                          <Box px={0}>
                            <Typography variant="caption" fontWeight="regular">
                              PRODUCT OPTIONS
                            </Typography>
                          </Box>
                          <Box mt={2}>
                            <Grid container spacing={{ xs: 1, md: 3 }}>
                              {productVariants.map((variant) => (
                                <Grid item xs={12} md={6} lg={6}>
                                  <TextField
                                    sx={{
                                      padding: "12px",
                                      paddingLeft: "3px",
                                    }}
                                    placeholder="Select product(s)"
                                    fullWidth
                                    select
                                    label={`${variant.title}`}
                                    onChange={(e) => {
                                      let optName = "";
                                      productVariants.every((v) => {
                                        if (v.reference === variant.reference) {
                                          v.options.every((o) => {
                                            if (
                                              o.reference === e.target.value
                                            ) {
                                              optName = o.title;
                                            }
                                            return true;
                                          });
                                        }
                                        return true;
                                      });
                                      const temVariants =
                                        selectCampaignProductVariants;
                                      if (temVariants.length === 0) {
                                        const obj = {
                                          reference: variant.reference,
                                          variant_title: variant.title,
                                          option: e.target.value,
                                          option_title: optName,
                                        };
                                        temVariants.push(obj);
                                        setSelectCampaignProductVariants(
                                          temVariants
                                        );
                                        return;
                                      }

                                      let exists = null;
                                      for (const [
                                        index,
                                        row,
                                      ] of temVariants.entries()) {
                                        if (
                                          row.reference === variant.reference
                                        ) {
                                          exists = index;
                                          break;
                                        }
                                      }

                                      if (exists !== null) {
                                        temVariants[exists].option =
                                          e.target.value;
                                        temVariants[exists].option_title =
                                          optName;
                                      } else {
                                        const obj = {
                                          reference: variant.reference,
                                          variant_title: variant.title,
                                          option: e.target.value,
                                          option_title: optName,
                                        };
                                        temVariants.push(obj);
                                      }
                                      // console.log(temVariants);
                                      setSelectCampaignProductVariants(
                                        temVariants
                                      );
                                    }}
                                  >
                                    {variant.options.length > 0 &&
                                      variant.options.map((opt) => (
                                        <MenuItem
                                          name={opt.title}
                                          // key={`${opt.reference}_${idx}`}
                                          value={opt.reference}
                                        >
                                          {opt.title}
                                        </MenuItem>
                                      ))}
                                  </TextField>
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                          <Box mt={3} mb={3}>
                            <Divider />
                          </Box>
                        </Box>
                      ) : (
                        <> </>
                      )} */}
                    </Box>
                    {productVariants.length > 0 ? (
                      <>
                        <Box mt={5} mb={5}>
                          <Typography variant="caption" fontWeight="regular">
                            PRODUCT OPTIONS
                          </Typography>
                          <Box mt={2}>
                            <Grid container spacing={3}>
                              {productVariants.map((variant, index) => (
                                <Grid
                                  item
                                  xs={6}
                                  md={4}
                                  lg={4}
                                  key={`variant_${index}`}
                                >
                                  <TextField
                                    fullWidth
                                    select
                                    // size="small"
                                    label={`${variant.title}`}
                                    onChange={(e) => {
                                      let optName = "";
                                      productVariants.every((v) => {
                                        if (v.reference === variant.reference) {
                                          v.options.every((o) => {
                                            if (
                                              o.reference === e.target.value
                                            ) {
                                              optName = o.title;
                                            }
                                            return true;
                                          });
                                        }
                                        return true;
                                      });
                                      let temVariants = selectedVariants;
                                      if (temVariants.length === 0) {
                                        const obj = {
                                          reference: variant.reference,
                                          variant_title: variant.title,
                                          option: e.target.value,
                                          option_title: optName,
                                        };
                                        temVariants.push(obj);
                                        setSelectedVariants(temVariants);
                                        return;
                                      }

                                      let exists = null;
                                      for (let [
                                        index,
                                        row,
                                      ] of temVariants.entries()) {
                                        if (
                                          row.reference === variant.reference
                                        ) {
                                          exists = index;
                                          break;
                                        }
                                      }

                                      if (exists !== null) {
                                        temVariants[exists].option =
                                          e.target.value;
                                        temVariants[exists].option_title =
                                          optName;
                                      } else {
                                        const obj = {
                                          reference: variant.reference,
                                          variant_title: variant.title,
                                          option: e.target.value,
                                          option_title: optName,
                                        };
                                        temVariants.push(obj);
                                      }
                                      setSelectedVariants(temVariants);
                                    }}
                                    SelectProps={{
                                      native: false,
                                    }}
                                  >
                                    {variant.options.length > 0 &&
                                      variant.options.map((opt, idx) => (
                                        <MenuItem
                                          name={opt.title}
                                          key={`${opt.reference}_${idx}`}
                                          value={opt.reference}
                                        >
                                          {opt.title}
                                        </MenuItem>
                                      ))}
                                  </TextField>
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <> </>
                    )}
                    {product.order_restriction === "MULTIPLE" ? (
                      <Box mt={5}>
                        <Box px={0}>
                          <Typography variant="caption" fontWeight="regular">
                            ORDER QUANTITY
                          </Typography>
                        </Box>
                        <Box mt={3}>
                          <TextField
                            sx={{
                              size: {
                                xs: "small",
                                md: "large",
                                lg: "large",
                              },
                            }}
                            value={selectedQuantity}
                            type="number"
                            label="Quantity"
                            fullWidth
                            onChange={(e) => {
                              const qty = parseInt(e.target.value, 10);
                              setSelectedQuantity(qty);
                            }}
                          />
                        </Box>
                      </Box>
                    ) : (
                      <> </>
                    )}

                    {/* <Box mt={5} mb={10}>
                      <Box>
                        <TextField
                          value={selectedQty}
                          size="small"
                          type="number"
                          label="Quantity"
                          onChange={(e) =>
                            setSelectedQty(parseInt(e.target.value, 10))
                          }
                        />
                      </Box>
                    </Box> */}
                    <Box mt={5} mb={1}>
                      <Button
                        // fullWidth
                        variant="contained"
                        color="primary"
                        size="large"
                        endIcon={<Icon>arrow_forward_rounded</Icon>}
                        onClick={() => addToCart()}
                      >
                        Buy Now
                      </Button>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            </Grid>
            <Box my={5}>
              <Divider />
            </Box>
            <Box mt={0} mb={3} px={1}>
              <Typography variant="subtitle1" fontWeight={500}>
                Description
              </Typography>
              <Typography variant="body2" fontWeight={100} mt={1}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: productDescription,
                  }}
                />
              </Typography>
            </Box>
          </Box>
        ) : (
          <> </>
        )}
      </Container>
      <CheckoutFooter />
    </>
  );
}

export default AgentProductPage;
